import http from "../../api/constants/http";
import filterProductList from "../../common/util/filterProduct";
import searchItemsByText from "../../common/util/searchItemsByText";
import * as Types from "../constants/actionTypes";

// Fetch Product fetchProduct
export const fetchProduct = (url, filters, body) => async (dispatch) => {
  try {
    const res = await http(url).post(body);
    const resData = {
      code: res.data?.Code,
      data: res.data.Data?.Rows,
    };
    const filteredList = filterProductList(resData.data, filters, body);

    dispatch({
      type: Types.FETCHED_PRODUCT,
      payload: { products: filteredList },
    });
    return "complete";
  } catch (error) {
    return error;
  }
};
